import React from 'react'

import {  Footer, Header } from '../components/layout'
import { ProductDetails } from '../components/products'
import {backgroundDark,backgroundLight} from "../assets/images"
import { useStateContext } from '../context/ContextProvider'

const Products_Details = () => {
    const {currentMode}=useStateContext()
    const bgImage = currentMode === 'Dark' ? backgroundDark : backgroundLight;
    return (
      <div className='w-full'
      style={{ backgroundImage: `url(${bgImage})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
      >
        <Header activeLink={"/Products"} />
<ProductDetails/>
        <Footer />
        </div>
  )
}

export default Products_Details